import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { Eye, EyeOff } from "lucide-react";
import useAuth from "../../Auth/useAuth";
import videoFile from "../../Images/truck1.mp4"; // Import the video file
import logo from "../../Images/logo.jpg";
import "./Login.css";
import ResetPassword from "../../Components/ResetPassword/ResetPassword";
import config from "../../config";

axios.defaults.baseURL = `${config.BASE_URL}`;

const Login = () => {
  const { setIsAuthenticated } = useAuth();
  const [showResetModal, setShowResetModal] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [businessError, setBusinessError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [progress, setProgress] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const [business, setBusiness] = useState(Cookies.get("token") || "");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Clear previous errors
    setUsernameError("");
    setPasswordError("");
    setBusinessError("");

    if (!business || !username || !password) {
      if (!business) {
        setBusinessError("Please select a business");
      }
      if (!username) {
        setUsernameError("Username is required");
      }
      if (!password) {
        setPasswordError("Password is required");
      }
      return;
    }

    setIsProcessing(true);
    setStatusMessage("Authenticating your credentials...");
    setProgress(25);

    try {
      const response = await axios.post(
        "/login",
        { username, password, business },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      console.log("Response from server:", response.data);

      if (!response.data.profile) {
        setStatusMessage("");
        setProgress(0);
        setIsProcessing(false);
        alert("Unauthorized access");
        return;
      }

      setProgress(50);

      if (response.status === 200) {
        setTimeout(() => {
          setStatusMessage("Access granted! Loading dashboard...");
          setProgress(80);

          setTimeout(() => {
            setStatusMessage("Welcome to Logistics Dashboard!");
            setProgress(100);

            setTimeout(() => {
              setIsAuthenticated(
                true,
                username,
                response.data.profile,
                response.data.business,
              );
              console.log("Cookies received from server ", document.cookie);
              navigate("/home");
            }, 1000);
          }, 1000);
        }, 1000);
      }
    } catch (error) {
      setStatusMessage("");
      setProgress(0);
      setIsProcessing(false);

      console.log("Full error object:", error);

      if (error.response) {
        const errorMsg = error.response.data.message || "";

        if (errorMsg === "User not found") {
          setUsernameError("❌ User not found. Please check your username.");
        } else if (errorMsg === "Invalid password") {
          setPasswordError("❌ Incorrect password. Please try again.");
        } else {
          alert(errorMsg || "An unexpected error occurred. Please try again.");
        }
      } else if (error.request) {
        console.error("No response received:", error.request);
        alert("⚠️ Connection error. Please check your internet connection.");
      } else {
        console.error("Error:", error.message);
        alert("An unexpected error occurred. Please try again.");
      }
    }
  };

  return (
    <>
      {isProcessing && (
        <div className="login-fullscreen-overlay">
          <div className="login-progress-container">
            <div className="login-progress-visual">
              <div className="login-progress-truck"></div>
              <div className="login-progress-road"></div>
            </div>
            <div className="login-status-message">{statusMessage}</div>
            <div className="login-progress-bar">
              <div
                className="login-progress-fill"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <div className="login-progress-percentage">{progress}%</div>
          </div>
        </div>
      )}

      {/* <div className="login-background">
        <div className="animator-login-container"></div>
        <div className="moving-truck truck-1">
          <div className="truck-wheel" style={{ left: "15px" }}></div>
          <div className="truck-wheel" style={{ left: "95px" }}></div>
        </div>
        <div className="moving-truck truck-2">
          <div className="truck-wheel" style={{ left: "15px" }}></div>
          <div className="truck-wheel" style={{ left: "95px" }}></div>
        </div>
        <div className="moving-truck truck-3">
          <div className="truck-wheel" style={{ left: "15px" }}></div>
          <div className="truck-wheel" style={{ left: "95px" }}></div>
        </div>
        <div className="delivery-message delivery-1">
          🚛 1000+ Successful Deliveries
          <br />⭐ 98% Customer Satisfaction
        </div>
        <div className="delivery-message delivery-2">
          📍 Real-time Tracking
          <br />
          ⏱️ On-time Delivery Guarantee
        </div>
        <div className="delivery-message delivery-3">
          🔒 Secure Logistics Network
          <br />
          📊 Smart Fleet Management
        </div>
      </div> */}
      
      

      <div className="login-container">
        <div className="login-card">
          <div className="login-logo-container">
            <img src={logo} alt="Logistics Logo" className="login-logo" />
          </div>

          <div className="login-header">
            <h2>MFT Logistics</h2>
            <h4>Login</h4>
            {/* <p>Login to your logistics management account</p> */}
          </div>

          <form
            autoComplete="off"
            onSubmit={handleSubmit}
            className="login-form"
          >
            <div className="login-form-group">
              <label htmlFor="business">Business *</label>
              <select
                id="business"
                name="business"
                value={business}
                onChange={(e) => {
                  setBusiness(e.target.value);
                  setBusinessError("");
                }}
                required
                className={`login-input ${businessError ? "login-input-error" : ""}`}
              >
                <option value="">Select business</option>
                <option value="shree">Business 1</option>
                <option value="lalchand">Business 2</option>
              </select>
              {businessError && (
                <span className="login-error-message">⚠️ {businessError}</span>
              )}
            </div>

            <div className="login-form-group">
              <label htmlFor="username">Username *</label>
              <input
                type="text"
                id="username"
                autoComplete="off"
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setUsernameError("");
                }}
                required
                placeholder="Enter your username"
                className={`login-input ${usernameError ? "login-input-error" : ""}`}
              />
              {usernameError && (
                <span className="login-error-message">⚠️ {usernameError}</span>
              )}
            </div>

            <div className="login-form-group">
              <label htmlFor="password">Password *</label>

              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setPasswordError("");
                  }}
                  required
                  placeholder="Enter your password"
                  className={`login-input ${passwordError ? "login-input-error" : ""}`}
                />

                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>

              {passwordError && (
                <span className="login-error-message">⚠️ {passwordError}</span>
              )}
            </div>

            <button className="login-submit-button" type="submit">
              Login
            </button>
          </form>

          <div className="login-links">
            <div className="login-link-text">
              Don't have an account?{" "}
              <span
                className="login-link-action"
                onClick={() => navigate("/signup")}
              >
                Create Account
              </span>
            </div>
            <div className="login-link-text">
              Forgot Password?{" "}
              <span
                className="login-link-action"
                onClick={() => setShowResetModal(true)}
              >
                Reset Password
              </span>
            </div>
          </div>
        </div>

        {showResetModal && (
          <ResetPassword onClose={() => setShowResetModal(false)} />
        )}
      </div>
    </>
  );
};

export default Login;
